/**
 * OtpExceededRetries Component
 */
import { resetCardState } from "containers/Card/store/Actions";
import { CardAction } from "containers/Card/store/CardAction";
import { CardState } from "containers/Card/store/CardState";
import * as React from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { CajitaStore } from "root/store/CajitaStore";

interface IModalState {
  currentOtp: string;
}

// tslint:disable-next-line:completed-docs
class OtpExceededRetriesComponent extends React.Component<
  CardState,
  IModalState
> {
  constructor(props: CardState) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <div className={"exceeded-retries-wrapper"}>
        <h1 className={"exceeded-title"}>
          <Translate id={"exceededRetries.title"} />
        </h1>
        <p className={"exceeded-description"}>
          <Translate id={"exceededRetries.description"} />
        </p>
        <p className={"exceeded-note"}>
          <Translate id={"exceededRetries.note"} />
        </p>
        <div className="button exceeded-button">
          <Button
            color={"primary"}
            type="button"
            className={"btn confirm-button"}
            onClick={(): void => this.props.resetCardState()}
          >
            <Translate id={"exceededRetries.button"} />
          </Button>
        </div>
      </div>
    );
  }
}

// istanbul ignore next
const mapStateToProps: (state: CajitaStore) => CardState = (
  state: CajitaStore
): CardState => ({
  ...state.card,
});

// istanbul ignore next
const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, CardAction>
): object => ({
  resetCardState: (): void => dispatch(resetCardState()),
});

const OtpExceededRetriesContainer: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(OtpExceededRetriesComponent);

export { OtpExceededRetriesContainer };



// WEBPACK FOOTER //
// ./src/components/WaitingView/OtpExceededRetriesComponent.tsx